module.exports = __webpack_public_path__ + "static/media/whatfixvideo.a69a7568.webm";